{
  "version": 1,
  "asset_id": "d6812cf1-3d62-48d4-9e62-a3264c1b1bfd",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d6812cf1-3d62-48d4-9e62-a3264c1b1bfd/sleeve-to-bypass-first-view-es-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d6812cf1-3d62-48d4-9e62-a3264c1b1bfd/sleeve-to-bypass-first-view-es-640.webp",
  "original_filename": "sleeve-to-bypass-first-view-es-640.webp",
  "size": 29266,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:34:00Z"
}
